"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const client = require("@prismicio/client");
const isReleasePreview = require("./isReleasePreview.cjs");
const fetchPublishedDocumentIDs = async ({ client: client$1, abortController, pluginOptions }) => {
  if (isReleasePreview.isReleasePreview()) {
    const endpoint = pluginOptions.graphQLEndpoint || client.getGraphQLEndpoint(pluginOptions.repositoryName);
    const existingIDs = [];
    let after;
    let hasNextPage = false;
    do {
      const url = new URL(endpoint);
      const afterStr = after ? `,after:"${after}"` : "";
      url.searchParams.set("query", `query AllDocumentIDs{_allDocuments(first:100${afterStr}){pageInfo{endCursor,hasNextPage}edges{node{_meta{id}}}}}`);
      const res = await client$1.graphQLFetch(url.toString(), {
        signal: abortController.signal
      });
      const json = await res.json();
      for (let i = 0; i < json.data._allDocuments.edges.length; i++) {
        existingIDs.push(json.data._allDocuments.edges[i].node._meta.id);
      }
      after = json.data._allDocuments.pageInfo.endCursor;
      hasNextPage = json.data._allDocuments.pageInfo.hasNextPage;
    } while (hasNextPage);
    return existingIDs;
  } else {
    return [];
  }
};
exports.fetchPublishedDocumentIDs = fetchPublishedDocumentIDs;
//# sourceMappingURL=fetchPublishedDocumentIDs.cjs.map
